import React from 'react';
import { Box, Typography } from '@mui/material';

// Environment variables injected at build time
const getVersionInfo = () => {
  // Get version from package.json via import.meta.env or define fallbacks
  const version = import.meta.env.VITE_APP_VERSION;
  const gitCommit = import.meta.env.VITE_GIT_COMMIT ?? 'dev';
  const buildTime = import.meta.env.VITE_BUILD_TIME ?? new Date().toISOString();

  return { version, gitCommit, buildTime };
};

const Footer: React.FC = () => {
  const { version, gitCommit, buildTime } = getVersionInfo();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        opacity: 0.7,
        fontSize: '0.75rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} Polar Electro
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="caption" color="text.secondary">
            v{version}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
            {gitCommit.length > 7 ? gitCommit.substring(0, 7) : gitCommit}
          </Typography>
          <Typography variant="caption" color="text.secondary" title={buildTime}>
            {new Date(buildTime).toLocaleDateString()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
